import { theme } from "antd";
import { useState } from "react";

const themeBaseColor ='#722ed1'


const baseThemeConfig = {
  token: {
    "fontSize": 18,
    "borderRadius": 4,
    "wireframe": false,
    "colorPrimary": themeBaseColor,
    "colorInfo": themeBaseColor,
  },
  "components": {
    "Menu": {
      "itemHeight": 50,
      "itemSelectedBg": "rgb(114,46,209)",
      "itemSelectedColor": "rgb(255,255,255)"
    },
    "Form": {
      "itemMarginBottom": 32
    },
    "Drawer": {
      "colorBgMask": "rgba(0,0,0,0.5)"
    }
  }
  // "components": {
  //   "Segmented": {
  //     "itemSelectedBg": themeBaseColor,
  //     "itemSelectedColor": "#FFFFF"
  //   }
  // }
};
const customDarkTheme = {
  ...baseThemeConfig,
  algorithm: theme.darkAlgorithm,
   components: {
    ...baseThemeConfig.components,
    Menu: {
      ...baseThemeConfig.components.Menu,
      // itemSelectedBg: "#162312",  // Dark background
      
    }
  }
}
const customDefaultTheme = {
  ...baseThemeConfig,
  algorithm: theme.defaultAlgorithm,
   colorNoContainer: "#e73737ff",
}

export { customDefaultTheme, customDarkTheme };


